import { render } from "./LoginProvider.vue?vue&type=template&id=6555a561"
import script from "./LoginProvider.vue?vue&type=script&lang=js"
export * from "./LoginProvider.vue?vue&type=script&lang=js"

import "./LoginProvider.vue?vue&type=style&index=0&id=6555a561&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__